import React from 'react';
import { MobileShell } from '../components/ui/MobileShell';
import { HeaderBar } from '../components/ui/HeaderBar';
import { PillButton } from '../components/ui/PillButton';
import { Card } from '../components/ui/ContentCard';
import { FieldInput } from '../components/ui/FieldInput';
import { Logo } from '../components/ui/Logo';

// Dev-only route (/style-guide) rendering every Phase-1 component + variant
// for design review before Phase-2 re-skinning begins.
function Section({ title, children }) {
  return (
    <div className="space-y-3 border-b border-gray-200 px-4 py-6">
      <h2 className="text-sm font-bold uppercase tracking-wide text-gray-500">{title}</h2>
      {children}
    </div>
  );
}

export default function StyleGuide() {
  return (
    <MobileShell>
      <HeaderBar title="Style Guide" />

      <Section title="Header Bar">
        <HeaderBar title="Local Attorneys" />
      </Section>

      <Section title="Pill Button — variants">
        <p className="text-sm text-gray-600">primary</p>
        <PillButton variant="primary">Start Your Review</PillButton>
        <p className="text-sm text-gray-600">secondary</p>
        <PillButton variant="secondary">Send Verification Code</PillButton>
        <p className="text-sm text-gray-600">danger</p>
        <PillButton variant="danger">RESCAN</PillButton>
        <p className="text-sm text-gray-600">soft</p>
        <PillButton variant="soft">Go Back</PillButton>
        <p className="text-sm text-gray-600">disabled</p>
        <PillButton disabled>Disabled</PillButton>
      </Section>

      <Section title="Card — variants">
        <Card variant="report">
          <h3 className="font-bold">Compliance Overview (report)</h3>
          <p className="text-sm">Light blue report card.</p>
        </Card>
        <Card variant="reportAlt">
          <h3 className="font-bold">Risk Factors (reportAlt)</h3>
          <p className="text-sm">Deeper blue alternating card.</p>
        </Card>
        <Card variant="attorney">
          <h3 className="font-bold">John Smith (attorney)</h3>
          <p className="text-sm">Pale sage attorney profile card.</p>
        </Card>
        <Card variant="plain">
          <h3 className="font-bold">Plain</h3>
          <p className="text-sm">Light gray plain card.</p>
        </Card>
      </Section>

      <Section title="Field Input">
        <FieldInput label="Your Email" placeholder="Enter your email" value="" onChange={() => {}} />
        <FieldInput placeholder="Verification code" value="" onChange={() => {}} />
        <FieldInput label="Your Message" placeholder="Your Message" value="" onChange={() => {}} textarea />
      </Section>

      <Section title="Logo — sizes">
        <div className="flex flex-wrap items-end gap-4">
          <Logo size="sm" />
          <Logo size="md" />
          <Logo size="lg" />
        </div>
      </Section>
    </MobileShell>
  );
}
